
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    BIPS: "BIPS",
    BPS: "BPS",
    KBIS: "KBIS",
    KBS: "KBS",
    MBIS: "MBIS",
    MBS: "MBS",
    GBIS: "GBIS",
    GBS: "GBS"
};
